// Exact UI action labels, expanded from shared nouns during localization.
export const actionEnglish: Record<string,string> = {
  "关闭用量与额度详情": "Close usage and limits details",
  "关闭添加长文": "Close add an article",
  "关闭充值弹窗": "Close add credit",
  "关闭日历": "Close calendar",
  "关闭当天内容": "Close this day's content",
  "关闭通话详情": "Close call details",
  "返回联系人与通话入口": "Back to contacts & calls",
  "打开联系人与通话入口": "Open contacts & calls",
  "返回联系人选择": "Back to contact selection",
  "关闭通话邀请": "Close call invitation",
  "关闭联系人选择": "Close contact selection",
  "关闭通话引导": "Close call tour",
  "关闭录像": "Close video recording",
  "关闭成员快记": "Close member notes",
  "关闭聊天预览": "Close chat preview",
  "关闭二维码识别": "Close qR code scanner",
  "关闭聊天搜索": "Close chat search",
  "关闭我的一天": "Close my day",
  "关闭活动详情": "Close activity details",
  "关闭回复列表": "Close replies",
  "关闭分享弹窗": "Close share",
  "关闭文件预览": "Close file preview",
  "关闭群成员": "Close group members",
  "返回规则列表": "Back to rules",
  "关闭禁止加入名单": "Close blocked members",
  "查看群成员": "View group members",
  "关闭功能引导": "Close feature tour",
  "关闭长文": "Close articles",
  "关闭扩展详情": "Close extension details",
  "关闭市集": "Close marketplace",
  "关闭会员窗口": "Close membership dialog",
  "关闭转发对象选择": "Close forwarding destinations",
  "关闭举报": "Close report",
  "关闭快记详情": "Close note details",
  "返回快记详情": "Back to note details",
  "返回相关快记列表": "Back to related notes list",
  "关闭插件更新": "Close extension updates",
  "关闭录音体验": "Close recording tour",
  "关闭预览": "Close preview",
  "关闭截图": "Close screenshot",
  "关闭全局搜索": "Close search everywhere",
  "返回搜索": "Back to search",
  "关闭发给自己引导": "Close saved notes tour",
  "关闭添加联系人": "Close add contact",
  "关闭指定主题": "Close choose topic",
  "关闭主题": "Close topics",
  "关闭登录": "Close sign in",
  "关闭图片预览": "Close image preview",
  "关闭发布窗口": "Close post dialog",
  "关闭上传文件": "Close upload files",
  "关闭已完成": "Close completed",
  "关闭录音引导": "Close recording guide",
  "关闭说话人编辑": "Close speaker editor",
  "关闭当前窗口说话人统计": "Close speaker statistics for this range",
  "关闭转写对比": "Close compare transcripts",
  "返回转发对象": "Back to forwarding destination",
  "关闭录音转发": "Close forward recording",
  "关闭工作区选择": "Close workspace picker",
  "关闭修改备注": "Close edit contact name",
  "关闭相关录音": "Close related recordings",
  "关闭录音详情": "Close recording details"
}
